import * as Sentry from '@sentry/vue';

const mergeCaptureContext = (errorContext, callerContext) => {
    if (!errorContext) return callerContext;
    if (!callerContext) return errorContext;
    return {
        ...errorContext,
        ...callerContext,
        tags: { ...errorContext.tags, ...callerContext.tags },
        contexts: { ...errorContext.contexts, ...callerContext.contexts },
    };
};

/**
 * Send an error to Sentry (or console.error in dev).
 *
 * If the error carries a `sentryContext` property (attached by the axios
 * response interceptor), it is merged with `captureContext`. Caller-supplied
 * tags/contexts override the interceptor's at the leaf level.
 *
 * @param {Error|unknown} error - The error to report.
 * @param {Object} [captureContext] - Optional Sentry CaptureContext
 *     ({ tags, extra, level, contexts, fingerprint, ... }).
 */
const logger = (error, captureContext) => {
    const context = mergeCaptureContext(error?.sentryContext, captureContext);

    if (process.env.VUE_APP_SENTRY_ENABLED === 'true') {
        Sentry.captureException(error, context);
    } else {
        // eslint-disable-next-line no-console
        console.error(error, context);
    }
};

export { logger as default };
